import React from 'react';
import { BrowserRouter, Route, Switch, Link, NavLink, Router } from 'react-router-dom';
import createHistory from 'history/createBrowserHistory';
import MunicipalProfilePage from '../components/MunicipalProfilePage';
import MainForecastPage from '../components/populationForecast/MainForecastPage';
import EconomicProfilePage from '../components/EconomicProfilePage';
import EconomicModelPage from '../components/EconomicModelPage';
import NotFoundPage from '../components/NotFoundPage';
import PublicRoute from './PublicRoute';
import PrivateRoute from './PrivateRoute';
import EconomicModelDashboard from '../components/economicModel/Dashboard';
import ErrorPage from '../components/ErrorPage';

export const history = createHistory();

const AppRouter = () => (
  <Router history={history}>
    <div>
      <Switch>
        <PublicRoute path="/" component={MunicipalProfilePage}  exact={true} />
        <PublicRoute path="/populationforecast" component={MainForecastPage}  />
        <PublicRoute path="/economicprofile" component={EconomicProfilePage}  />
        <PublicRoute path="/economicmodel" component={EconomicModelPage}  />
        <PrivateRoute path="/economicmodeldashboard" component={EconomicModelDashboard}  />
        <Route component={NotFoundPage} />
      </Switch>
    </div>
  </Router>
);

export default AppRouter;


// WEBPACK FOOTER //
// ./src/routers/AppRouter.js